"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  address: 'Address',
  addressResults: '({count} results)',
  addressSearch: 'Address search',
  addressType: 'Address Type',
  addressTypeLabelChannel: 'Channel',
  addressTypeLabelDelivery: 'Delivery',
  addressTypeLabelHome: 'Home',
  addressTypeLabelKyc: 'KYC',
  addressTypeLabelOther: 'Other',
  addressTypeLabelSubscription: 'Subscription',
  area: 'Area',
  areaPlaceholder: 'Enter area',
  cancel: 'Cancel',
  cannotGetData: 'Cannot get data from server',
  city: 'City',
  cityPlaceholder: 'Enter city',
  confirm: 'Confirm',
  confirmAddressDelete: 'Do you want to delete?',
  confirmAddressDeleteInfo: 'Are you sure you want to delete your address? You won’t be able to undo.',
  country: 'Country',
  defaultHint: 'Please enter field',
  deleteAddress: 'Delete address',
  delivery: 'Delivery',
  delivery2: 'Delivery 2',
  delivery2Placeholder: 'Delivery 2 information',
  delivery3: 'Delivery 3',
  delivery3Placeholder: 'Delivery 3 information',
  deliveryPlaceholder: 'Delivery information',
  district: 'District',
  districtPlaceholder: 'Enter district',
  errorOccurred: 'An error occurred',
  errorSearchAddressAutocomplete: 'You have to search for city or zip',
  hintArea: 'Please enter your area',
  hintAutocomplete: 'Search address by zip code or city',
  hintCity: 'Please enter your city',
  hintCountry: 'Please enter your country',
  hintDelivery: 'Please enter your delivery',
  hintDistrict: 'Please enter your district',
  hintLocality: 'Please enter your locality',
  hintProvince: 'Please enter your province',
  hintRegion: 'Please enter your region',
  hintStreetAddress: 'Please enter your street address',
  hintZipCode: 'Please enter your postal code',
  isPrimary: 'Use as primary address',
  locality: 'Locality',
  localityPlaceholder: 'Enter locality',
  noSuggestions: 'No suggestions',
  province: 'Province',
  provincePlaceholder: 'Enter province',
  region: 'Region',
  regionPlaceholder: 'Enter region',
  save: 'Save',
  searchAddress: 'Search address',
  searchAddressAutocompleteV2: 'Zip code / city',
  searchAddressPlaceholder: '--Search address--',
  searchForAnAddress: 'Search address',
  searchedAddress: 'Searched address',
  startTypingHere: 'Start typing here',
  streetAddress: 'Street address',
  streetPlaceholder: 'Enter street',
  typeAtLeastThreeCharacters: 'Type at least 3 characters',
  uniqueId: 'UniqueID',
  validationLength: 'Invalid property length',
  validationMaxLength: 'This field value should have maximum length of {max}',
  validationMinLength: 'This field value should have minimum length of {min}',
  validationMinValue: 'This field should have minimum value of {min}',
  validationRegex: 'This field value does not match requested conditions',
  validationRequired: 'This field is required',
  validationZipCodeStructure: 'Address does not match zip code structure',
  zipCodePlaceholder: 'Enter zip code',
  zipcode: 'Zip code'
};
const translationsNamespace = exports.translationsNamespace = 'address-form';
//# sourceMappingURL=defaultTranslations.js.map